import { getCustomData } from "~/utils/tracking/utils";
import type { ElementType } from "react";
import type { PrimaryButtonProps } from "@sb1/ffe-buttons-react";
import { PrimaryButton as FellesPrimaryButton } from "@sb1f/buttons";

type Props<As extends ElementType = "button"> = PrimaryButtonProps<As> & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const PrimaryButton = <As extends ElementType = "button">({ track = true, trackingData, ...props }: Props<As>) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesPrimaryButton customData={customData} {...props} />;
};

export default PrimaryButton;
